import { Box } from '@mui/material'
import { themeConstants } from '@paywithextend/components'
import React from 'react'
import styleVars from 'src/style/variables.json'
import { css } from 'styled-components'

const SidenavSelectedBar: React.ForwardRefRenderFunction<HTMLDivElement> = (
  props,
  ref,
) => {
  return (
    <Box
      ref={ref}
      sx={{ position: 'absolute', left: 0, top: 0, height: '100%' }}
      {...props}
    >
      <div
        css={css`
          width: ${styleVars.units['base-unit-1']}px;
          height: 100%;
          border-radius: 0 ${styleVars.units['base-unit-1']}px
            ${styleVars.units['base-unit-1']}px 0;
          background-color: ${themeConstants.colors.cta};
        `}
      />
    </Box>
  )
}
export default React.forwardRef(SidenavSelectedBar)
